/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from '../../utils/axiosInstance';
// ----------------------------------------------------------------------
const url = process.env.BACKEND_URL;
const initialState = {
  isLoading: false,
  error: null,
  products: [],
  product: null,
  corporateList: [],
  rentalCarList: [],
  saveBooking: [],
  saveFlights: [],
  saveBuses: [],
  saveActivities: [],
  saveHotels: [],
  saveHolidays: [],
  createBooking: null,
  fareQuotes: undefined,
  storeFareQuotes: undefined,
  flightFilterList: undefined,
  flightListAllRes: undefined,
  flightListAllDummyRes: undefined,
  flightListNameRes: undefined
};
const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getFlightListSuccess(state, action) {
      state.isLoading = false;
      state.flightListRes = action.payload;
    },
    getFlightConfirmSuccess(state, action) {
      state.isLoading = false;
      state.flightConfirmRes = action.payload;
    },
    getAirportListSuccess(state, action) {
      state.isLoading = false;
      state.airportListRes = action.payload;
    },
    getflightsFilterSuccess(state, action) {
      state.isLoading = false;
      state.flightFilterList = action.payload;
    },
    getCommonSuccess(state, action) {
      state.isLoading = false;
      state.commonRes = action.payload;
    },
    getAirportAllListSuccess(state, action) {
      state.isLoading = false;
      state.flightListAllRes = action.payload;
    },
    getAirportAllDummyListSuccess(state, action) {
      state.isLoading = false;
      state.flightListAllDummyRes = action.payload;
    },
    getAirportNameListSuccess(state, action) {
      state.isLoading = false;
      state.flightListNameRes = action.payload;
    },
    getAirportNameList1Success(state, action) {
      state.isLoading = false;
      state.flightListName1Res = action.payload;
    },
    getFlightDetailSuccess(state, action) {
      state.isLoading = false;
      state.flightDetailRes = action.payload;
    },
    getTicketConfirmSuccess(state, action) {
      state.isLoading = false;
      state.ticketConfirmRes = action.payload;
    },
    getReleasePNRSuccess(state, action) {
      state.isLoading = false;
      state.releasePNRConfirmRes = action.payload;
    },
    fareQuotessSuccess(state, action) {
      state.isLoading = false;
      state.fareQuotes = action.payload;
    },
    storeFareQuotessSuccess(state, action) {
      state.isLoading = false;
      state.storeFareQuotes = action.payload;
    },
  },
});
// Reducer
export default slice.reducer;
// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
export function getFlightList(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/flight/list`,
        filterParam
      );
      dispatch(slice.actions.getFlightListSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function flightConfirm(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/booking/flight`,
        filterParam
      );
      dispatch(slice.actions.getFlightConfirmSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function airportList(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/flight/airportList`,
        filterParam
      );
      dispatch(slice.actions.getAirportListSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function flightsFilter(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // `${url}/flight/filterList`,
      const response = await axiosInstance.post(
        `${url}/flight/filterList`,
        obj
      );
      dispatch(
        slice.actions.getflightsFilterSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.getflightsFilterSuccess(error));
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getCommon() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(
        `${url}/flight/flightCabinClass`
      );
      dispatch(slice.actions.getCommonSuccess(response.data.responseData));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getAirportAllList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/flight/search`, obj);
      dispatch(
        slice.actions.getAirportAllListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getAirportAllDummyList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/flight/listFlights`, obj);
      dispatch(
        slice.actions.getAirportAllDummyListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function airportNameList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/flight/airportList`,
        obj
      );
      dispatch(
        slice.actions.getAirportNameListSuccess(response.data?.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function airportNameList1(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/flight/airportList`,
        obj
      );
      dispatch(
        slice.actions.getAirportNameList1Success(response.data?.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function flightDetail(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/flight/flightDetails`,
        obj
      );
      dispatch(
        slice.actions.getFlightDetailSuccess(response.data?.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function ticketConfirm(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axiosInstance.post(`${url}/flight/ticket`, obj);
      dispatch(slice.actions.getTicketConfirmSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function releasePNR(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/flight/releasePNR`, obj);
      dispatch(slice.actions.getReleasePNRSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function fareQuotess(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/flight/fareQuotess`,
        obj
      );
      dispatch(slice.actions.fareQuotessSuccess(response.data.responseData));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function storeFareQuotess(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.storeFareQuotessSuccess(obj));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function clearFareQuotess(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.storeFareQuotessSuccess(undefined));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function clearListData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.getAirportAllListSuccess(undefined));
  };
}
export function clearFilterData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.getflightsFilterSuccess(undefined));
  };
}